<template>
    <div class="login mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <div class="my-2">
            <p>請登入會員Email會員資料已完成Line綁定</p>
            <p>綁定後，可操作訂單及HiQuiz頁面</p>
        </div>
        <!-- 輸入電話資料  -->
        <div class="loginForm Form">
            <div class="account mx-auto">
                <font-awesome-icon class="icon" :icon="['far','circle-user']" />
                <input type="text" class="accountInput" placeholder="請輸入信箱帳號" v-model="email">
            </div>
            <div class="pwd mx-auto mt-3">
                <font-awesome-icon class="icon" :icon="['fas','lock']"/>
                <input type="password" class="pwdInput" placeholder="請輸入密碼" v-model="pwd">
            </div>
        </div>
        <div class="my-3">
            <div class="btn loginBtn" @click="Login()">登入</div>
        </div>
        <div class="loginBottom d-flex justify-content-center">
            <!-- 加入會員 -->
            <div @click="goRegister()">
                <font-awesome-icon class="icon" :icon="['fas','user-plus']" />
                <span class="joinMb">加入會員</span>
            </div>
            <!-- 忘記密碼 -->
            <!--<span class="mx-2"> | </span>
            <div @click="">
                <font-awesome-icon class="icon" :icon="['far','circle-question']" />
                <span class="fgtpwd">忘記密碼</span>
            </div>-->
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'

export default {
    name: 'Login',
    components:{
        Nav,
    },
    data () {
        return {
            Token:'',
            email:'',
            pwd:'',
            ProviderUserId:'',
            AccessToken:'',
            UserData:{},
            showLoading:false,
        }
    },
    methods:{
        goRegister(){
            this.$router.push({
                name: 'Register',
            });
        },
        //登入
        Login(){
            this.showLoading = true;
            //登入驗證-輸入email及密碼
            const api =`${process.env.APIPATH}/api/Login/CheckUserForEmailPassword`;
            const inputdata = 
            {
                "email":this.email,
                "password":this.pwd,
                "providerUserId":this.ProviderUserId,
                "providerId":1, // Line用,
                "accessToken":this.AccessToken,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){ //有資料true，跳電話驗證頁
                        this.UserData = response.data.userData;
                        sessionStorage.setItem('UserData',JSON.stringify(this.UserData));
                        this.$router.push({
                            name: 'TelVerification',
                        });
                        
                    }else{//無資料為false，則跳註冊頁
                        alert(response.data.message)
                        // this.$router.push({
                        //     name: 'Register',
                        // });
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
    },
    created(){
        this.AccessToken = sessionStorage.getItem('AccessToken');
        this.ProviderUserId = JSON.parse(sessionStorage.getItem('profile')).userId;
        // this.providerUserId = sessionStorage.getItem('providerUserId');
    },
}
</script>




// WEBPACK FOOTER //
// src/components/line/Login.vue